import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "63",
  height: "63",
  viewBox: "0 0 63 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31.5 0C14.103 0 0 14.103 0 31.5C0 48.897 14.103 63 31.5 63C48.897 63 63 48.897 63 31.5C63 14.103 48.897 0 31.5 0ZM48.0718 24.0394L28.8004 43.311C28.1998 43.9117 27.4125 44.2121 26.6253 44.2121C25.838 44.2121 25.0507 43.9117 24.4501 43.311L24.4483 43.3093L14.9282 33.7892C13.7268 32.5879 13.7268 30.6401 14.9282 29.4388C16.1295 28.2375 18.0772 28.2374 19.2786 29.4388L26.6253 36.7854L43.7215 19.6891C44.9227 18.4878 46.8705 18.4877 48.0719 19.6891C49.2732 20.8903 49.2732 22.8381 48.0718 24.0394Z",
  fill: "#5DCBAE"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default render